import { render, staticRenderFns } from "./BuildingSummaryCard.vue?vue&type=template&id=2707b664&scoped=true&"
import script from "./BuildingSummaryCard.vue?vue&type=script&lang=js&"
export * from "./BuildingSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSummaryCard.vue?vue&type=style&index=0&id=2707b664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707b664",
  null
  
)

export default component.exports